import { JobStatusType } from "@nova/constants"
import { InspectorPanelSettingsFields } from "../InspectorPanelSettingsFields"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ButtonPrimary } from "@nova/component-btn"
import { clearSelection } from "panels/content/side-panel/slice.new"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"
import { openVideoFlight } from "plugins/Video/state/thunks"

export const InspectorPanelVideoLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectVideoFlightById(id))
    if (!flight) return null
    const videoExists = flight.job?.status === JobStatusType.COMPLETED

    return (
        <>
            <InspectorPanelSettingsFields shouldShowTopBorder={false}>
                {videoExists && (
                    <ButtonPrimary
                        title="Play Video"
                        RightIcon={Icons.PlayCircle}
                        className="mb-2"
                        onClick={() => {
                            dispatch(clearSelection())
                            dispatch(openVideoFlight({ flightId: id }))
                        }}
                    />
                )}
            </InspectorPanelSettingsFields>
        </>
    )
}
